export const InsuranceRequirement = 'insurance_requirement';
export const InsuranceRequirementDocument = 'insurance_requirement_document';
export const InsurancePolicy = 'insurance_policy';
export const InsuranceDocument = 'insurance_document';
export const Insured = 'insured';
export const Job = 'job';
export const Item = 'item';
export const Template = 'template';
